"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_KIOSK_CONFIG_SCHEMA = exports.KIOSK_TYPES = void 0;
exports.getKioskType = getKioskType;
exports.validateKioskConfig = validateKioskConfig;
exports.listKioskTypeIds = listKioskTypeIds;
const zod_1 = require("zod");
const kiosk_config_schemas_1 = require("./kiosk-config.schemas");
exports.KIOSK_TYPES = {
    'oil-blending': {
        id: 'oil-blending',
        label: 'Oil Blending Kiosk',
        description: 'Customer self-serve build / browse blend kiosk. Submissions route to a linked POS register drawer.',
        icon: 'Sparkles',
        featureGate: 'pos.oil-blending.catalog',
        configSchema: kiosk_config_schemas_1.OilBlendingKioskConfigSchema,
        defaultConfig: {
            allowBuildYourOwn: true,
        },
    },
    // Future placeholders — uncomment + flesh out schema when ready.
    //
    // 'feedback': {
    //   id: 'feedback',
    //   label: 'Customer Feedback Kiosk',
    //   ...
    // },
    //
    // 'item-request': {
    //   id: 'item-request',
    //   label: 'Item Request Kiosk',
    //   ...
    // },
};
function getKioskType(id) {
    return exports.KIOSK_TYPES[id];
}
/**
 * Validate a config blob against the type's schema. Returns the parsed
 * config or throws a ZodError; caller decides how to surface to the API.
 */
function validateKioskConfig(kioskType, config) {
    const def = exports.KIOSK_TYPES[kioskType];
    if (!def) {
        throw new Error(`Unknown kioskType: ${kioskType}`);
    }
    return def.configSchema.parse(config ?? {});
}
/** All registered kiosk type IDs (for super-admin UI dropdowns). */
function listKioskTypeIds() {
    return Object.keys(exports.KIOSK_TYPES);
}
/** Marker so consumers can detect a "no schema" / fall-through case. */
exports.EMPTY_KIOSK_CONFIG_SCHEMA = kiosk_config_schemas_1.EmptyKioskConfigSchema;
// Avoid unused-import warning when the file is type-checked alone.
void zod_1.z;
//# sourceMappingURL=registry.js.map